module.exports = __webpack_public_path__ + "static/img4-0ae260d27e0a2c77c749d774cf572511.jpg";